module.exports = __webpack_public_path__ + "img/main-cup.f2848ca0.svg";